import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        canvasData: {
          userId: null,
          userFirstName: null,
          isAdmin: false,
          courseId: null,
        },

        quizData: {
          id: null,
          resourceId: null,
          itemId: null,
          isGraded: false,
          isEnrolled: false,
        },

        adminData: {
          userId: null,
          userFirstName: null,
        },
        
        welcomed: false,
      },
    
    mutations: {
      setInfo ( state, info ) {
        state.canvasData = { ...info }
      },

      setQuiz ( state, info ) {
        state.quizData = { ...info }
      },

      setAdminInfo ( state, info ) {
        state.adminData = { ...info }
      },
    },

    getters: {
      welcome: state => {
        return state.welcomed
      },
    },
})